import { http } from "../../utils/config";

/**
 * Đăng nhập CMS (module Shinko — bcrypt, không Redis).
 *
 * Trả về envelope `{ status, message, data: { access_token, type_user, permissions } }`.
 * Lỗi để nguyên cho nơi gọi dùng `errorMessage()`; trước đây thunk bọc lại thành
 * `new Error(...)` nên mất `response.status` — không phân biệt được sai mật khẩu
 * (401) với tài khoản bị khóa (403).
 */
export const loginUser = (data) =>
  http.post("/api/v1/shinko/cms/login", data).then((res) => res.data);

/** Thu hồi token phía server. Thất bại thì vẫn phải dọn phía client. */
export const logoutUser = () =>
  http.get("/auth/api/v1/logout").then((res) => res.data);
